import React from 'react';
import { FilterBlock } from 'src/pages/CatalogPage/components/FilterMenu/FilterMenu.style';

interface IFilterSection {
  isLoading: boolean;
  heading: string;
  children(): React.ReactNode;
}
// Header for Filter and handle loading status. Pass children as a function to only evaluate after loading is complete
export const FilterSection = ({ isLoading, heading, children }: IFilterSection) => (
  <FilterBlock isLoading={isLoading}>
    <h5>{heading}</h5>
    {isLoading ? '...' : children()}
  </FilterBlock>
);
